// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4y-2";
export var blackBorderOnHover = "_4y-7";
export var cell = "_4y-6";
export var cellContainer = "_4y-3";
export var checked = "_4y-8";
export var disabled = "_4y-5";
export var featuredIconCellContainer = "_4y-9";
export var featuredIconTextContainer = "_4y-b";
export var featuredIconWrapper = "_4y-a";
export var noBorder = "_4y-c";
export var orangeSelectedRow = "_c6-3";
export var overflowableText = "_4y-0";
export var overflowableTextContainer = "_4y-1";
export var row = "_51-0";
export var rowCheckboxCell = "_4y-4";
export var selectableTable = "_c6-2";